<template>
  <div class="cursor-default">
    <test v-show="false"></test>
    <div>
      <v-card class="mt-3" elevation="1">
        <v-card-text>
          <div class="mb-3" style="font-size: 1rem">
            <b>Увага!</b> Важлива інформація для респондентів
          </div>

          <div class="mb-2">
            Перед формуванням і поданням звітності обов’язково ознайомтеся з
            документом Кредитного реєстру Національного банку України –
            <a
              href="https://surveys.bank.gov.ua/about-NBUReestr/files/Description_FC_15.11.2024.docx"
              target="_blank"
              class="link d-inline">
              «Правила формування реквізитів та наборів даних, до яких включено
              ці реквізити, для подання звітності про активні операції».
            </a>
          </div>

          <div class="mb-2">
            Ознайомлення з цим документом є необхідною умовою для коректного
            заповнення звіту, дотримання встановлених вимог щодо звітності та
            запобігання можливим помилкам під час подання даних.
          </div>

          <div>
            Просимо уважно вивчити зазначений документ перед початком формування
            звіту.
          </div>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col
          v-for="(item, idx) in cards"
          :key="idx"
          cols="12"
          md="3"
          sm="12"
          :class="idx !== 0 && !mobile ? 'pl-0' : null"
          class="mt-3 gap-3">
          <CardItem
            :title="item.title"
            :color="item.color"
            :component="item.component"
            :description="item.description" />
        </v-col>
      </v-row>
      <v-card class="mt-3" elevation="1">
        <v-card-text>
          <h3 class="font-weight-bold mt-3 mb-2">Мої звіти</h3>
          <v-row>
            <v-col :cols="12" :md="4">
              <span class="text-blue-grey-lighten-2">
                Кількість відправлених пакетів
              </span>
              <div class="mt-3 d-flex align-center gap-3">
                <v-chip color="grey" rounded="circle" size="large">
                  <PackageCountIcon />
                </v-chip>
                <div>
                  <h4
                    v-if="
                      userData.watch_company_user_role.company
                        ?.current_company_tariff
                    "
                    class="font-weight-bold">
                    Всього:
                    {{
                      userData?.watch_company_user_role.company
                        ?.current_company_tariff?.sentPackagesCount || 0
                    }}
                  </h4>
                  <span v-else class="text-disabled">Тариф відсутній</span>
                </div>
              </div>
            </v-col>
            <v-col :cols="12" :md="4">
              <span class="text-blue-grey-lighten-2">
                Кількість прийнятих пакетів
              </span>
              <div class="mt-3 d-flex align-center gap-3">
                <v-chip color="grey" rounded="circle" size="large">
                  <v-icon
                    icon="mdi-text-box-check"
                    color="primary"
                    size="32"></v-icon>
                </v-chip>
                <div>
                  <h4
                    v-if="
                      userData.watch_company_user_role.company
                        ?.current_company_tariff
                    "
                    class="font-weight-bold">
                    Всього:
                    {{
                      userData?.watch_company_user_role.company
                        ?.current_company_tariff?.successPackagesCount || 0
                    }}
                  </h4>
                  <span v-else class="text-disabled">Тариф відсутній</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import CardItem from '@/pages/home/components/CardItem.vue'
import Test from './Test.vue'
import { onMounted } from 'vue'
import FileIcon from '@/assets/images/FileIcon.vue'
import IntegrationIcon from '@/assets/images/IntegrationIcon.vue'
import CheckCircleIcon from '@/assets/images/CheckCircleIcon.vue'
import CardIcon from '@/assets/images/CardIcon.vue'
import PackageCountIcon from '@/assets/images/PackageCountIcon.vue'
import { useUser } from '@/store/user.ts'
import { useDisplay } from 'vuetify'
import { useBreadcrumb } from '@/plugins/breadcrumb.js'
import BreadcrumbHeader from '@/pages/home/components/BreadcrumbHeader.vue'

export default {
  components: { PackageCountIcon, CardItem, Test },
  setup() {
    const { userData } = useUser()
    const { mobile } = useDisplay()
    const breadcrumb = useBreadcrumb()

    const cards = [
      {
        title: 'Швидке заповнення',
        component: CardIcon,
        description:
          'Ми підготували всі дані в зручні таблиці – вам залишається лише заповнити їх.',
        color: 'blue',
      },
      {
        title: 'Валідація даних',
        component: CheckCircleIcon,
        description:
          'Заповніть поля, а ми перевіримо та покажемо, якщо є помилки.',
        color: 'green',
      },
      {
        title: 'Генерація звіту',
        component: FileIcon,
        description:
          'Ми автоматично згенеруємо звіт і відправимо його до Кредитного реєстру.',
        color: 'yellow',
      },
      {
        title: 'Зв’язок з ERP',
        component: IntegrationIcon,
        description:
          'Працюйте у звичному середовищі – ми інтегруємось з вашою ERP.',
        color: 'red',
      },
    ]

    onMounted(() => {
      breadcrumb.setCardLabel({
        component: BreadcrumbHeader,
      })
    })

    return {
      cards,
      userData,
      mobile,
    }
  },
}
</script>
